<script setup>
defineProps({
    text: {
        type: String,
        required: true,
    },
    placement: {
        type: String,
        default: 'right',
        validator: value => ['right', 'bottom'].includes(value),
    },
    visible: {
        type: Boolean,
        default: false,
    },
})
</script>

<template>
    <span
        v-show="visible"
        :class="['nav-tooltip', `nav-tooltip-${placement}`]"
        role="tooltip"
    >{{ text }}</span>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.nav-tooltip {
    @include secondary;

    position: absolute;
    z-index: $layer-tooltip-z-index;
    padding: $space-4 $space-8;
    color: $c-text-primary;
    white-space: nowrap;
    pointer-events: none;
    border-radius: $radius-8;

    @include elevationOverlay;
}

.nav-tooltip-right {
    top: 50%;
    left: calc(100% + #{$space-8});
    transform: translateY(-50%);
}

.nav-tooltip-bottom {
    top: calc(100% + #{$space-8});
    left: 50%;
    transform: translateX(-50%);
}
</style>
